import { BusinessType } from '../../../../data-layer/business/types';
import { UserModel } from '../../../../data-layer/user/types';
import { BusinessRegistrationStatus } from '../../../../mappers/users/toUserModel';

export interface GetBusinessTypeParams {
    query: URLSearchParams;
    currentUser?: UserModel;
    businessTypeExp?: BusinessType;
}

export const getBusinessType = ({ currentUser, query, businessTypeExp }: GetBusinessTypeParams) => {
    // если зарегистрирован автор, то форсируем этот режим
    if (
        currentUser?.businessRegistrationStatus ===
        BusinessRegistrationStatus.MULTIPLE_ROLE_RESTRICTED
    ) {
        return BusinessType.BLOGGER;
    }

    if (businessTypeExp) {
        return businessTypeExp;
    }

    return (
        query.get('type') === BusinessType.BLOGGER ? BusinessType.BLOGGER : BusinessType.BUSINESS
    ) as BusinessType;
};
